



















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import cPopup from '@/components/default/Popup.vue';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import ordersService from '@/modules/orders/ordersService';

@Component({
  components: {
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
  },
})
export default class GeneratePurchaseOrderDocumentPopup extends Vue {
  @Prop({ required: true })
  id!: string;

  show: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  templates: any[] = [];
  languages: any[] = [];

  model: any = {
    template: '',
    language: '',
    groupArticlesByCategory: false,
  };

  public Open() {
    this.show = true;
  }

  mounted() {
    this.loadData();
  }

  async save() {
    try {
      const validationResult = (this.$refs.GeneratePurchaseOrderDocumentPopupForm as any).instance.validate();
      if (validationResult.isValid) {
        this.saving = true;

        await ordersService.generateDocument({
          id: this.id,
          template: this.model.template,
          language: this.model.language,
          groupArticlesByCategory: this.model.groupArticlesByCategory,
        });

        this.$emit('saved');
        this.show = false;
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  async loadData() {
    try {
      this.loading = true;
      this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];
      this.templates = (await ordersService.getTemplates()).data;
    } catch (err) {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het ophalen van de templates');
    } finally {
      this.loading = false;
    }
  }

  get templateOptions() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get fields() {
    return [
      {
        itemType: 'simple',
        dataField: 'template',
        editorOptions: this.templateOptions,
        editorType: 'dxSelectBox',
        label: {
          text: 'template',
        },
        validationRules: [{ type: 'required', message: 'Veld is verplicht' }],
      },
      {
        itemType: 'simple',
        dataField: 'language',
        editorOptions: this.languageOptions,
        editorType: 'dxSelectBox',
        label: {
          text: 'taal',
        },
      },
    ];
  }

  get languageOptions() {
    const items = this.languages.map((l) => ({
      value: l,
      text: l,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
      showClearButton: 'true',
    };
  }
}
